import React, { useMemo } from 'react'
import { staffStore } from '@/store/staff'
import { Modal } from '@/components/dialog/modal'
import { Column, Row } from '@/components/layout/layout'
import { shopStore } from '@/store/shop'
import { showLayer, layerManage } from '@/utils/layer'

import './auth.scss'
import { getCls } from '@/utils/classname'

interface AuthProps {
    perssion?: number
    onClick?: () => void
}

const AuthTip = () => {
    const cls = getCls('auth')

    return (
        <Modal
            showCancel={false}
            isShow
            width={352}
            type="success"
            okText="知道了"
            onConfirm={() => layerManage.pop()}
            onClose={() => layerManage.pop()}
        >
            <Column>
                <div className={cls('tip', 'title')}>暂无权限，请尝试联系以下人员</div>
                <Row className={cls('tip', 'container')} data-align-items-center data-margin-v-8>
                    <img
                        style={{
                            border: `1px solid ${shopStore.shopInfo?.creator.gender === 2 ? '#ee5b5b' : '#3c90ff'}`,
                        }}
                        className={cls('tip', 'avatar')}
                        alt=""
                        src={shopStore.shopInfo?.creator.avatar}
                    />
                    <Column data-height-50 data-justify-content-space-between data-margin-left-6>
                        <div className={cls('tip', 'realname')} data-font-weight-500>
                            {shopStore.shopInfo?.creator.realname}
                        </div>
                        <div className={cls('tip', 'realname')}>联系方式：{shopStore.shopInfo?.creator.phone}</div>
                    </Column>
                </Row>
            </Column>
        </Modal>
    )
}

const Auth: React.FC<AuthProps> = props => {
    const isCanUse = useMemo(() => (props.perssion ? staffStore.canIUse(props.perssion) : true), [props.perssion])

    return (
        <div
            style={{
                opacity: isCanUse ? 1 : 0.35,
                display: 'initial',
            }}
            onClick={e => {
                e.stopPropagation()
                if (isCanUse) {
                    props.onClick && props.onClick()
                } else {
                    showLayer(<AuthTip />)
                }
            }}
        >
            {props.children}
        </div>
    )
}

export default Auth
